<template>
  <section class="section">
    <Headline :level="2">Customer Infomation</Headline>
    <table class="table table-borderless">
      <tr>
        <th>Name</th>
        <td>{{ name | withPrefix | withEmpty }}</td>
      </tr>
      <tr>
        <th>Email</th>
        <td>{{ email | withEmpty }}</td>
      </tr>
      <tr>
        <th>Customer Number 会員番号</th>
        <td>{{ cmcNo | withEmpty }}</td>
      </tr>
    </table>
  </section>
</template>

<script>
import withEmpty from '@/filters/with-empty'

export default {
  props: {
    name: { type: String, required: true },
    email: { type: String, required: true },
    cmcNo: { type: String, required: true }
  },
  filters: {
    withEmpty,
    withPrefix: val => val ? `Mr./Ms. ${val}` : ''
  }
}
</script>
